module.exports = __webpack_public_path__ + "img/5.c889abd3.jpg";